// tslint:disable
export var NoteAggregateGroupBy;
(function (NoteAggregateGroupBy) {
    // Empty option
    NoteAggregateGroupBy[NoteAggregateGroupBy["None"] = 0] = "None";
    // Task type
    NoteAggregateGroupBy[NoteAggregateGroupBy["TaskType"] = 1] = "TaskType";
    // Task source (e.g Case or Account)
    NoteAggregateGroupBy[NoteAggregateGroupBy["TaskSource"] = 2] = "TaskSource";
})(NoteAggregateGroupBy || (NoteAggregateGroupBy = {}));
NoteAggregateGroupBy['NONE'] = 0;
NoteAggregateGroupBy['TASKTYPE'] = 1;
NoteAggregateGroupBy['TASKSOURCE'] = 2;
//# sourceMappingURL=NoteAggregateGroupBy.js.map